export enum ExerciseStatus {
    PENDING = 'pending',
    COMPLETED = 'completed',
}

export enum ExerciseType {
    QUIZ = 'quiz',
    HOMEWORK = 'homework',
}
